import React from 'react';
import styles from './styles.module.scss';

export default () => <div className={styles.loading}></div>;